import * as React from "react";
import type { SVGProps } from "react";
const SvgBabykino = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.031 96" {...props}>
    <path
      d="M959.126 328.754c7.824-9.811 16.611-12.437 20.538-19.29a17.714 17.714 0 0 0-6.429-24.091 17.426 17.426 0 0 0-23.913 6.434c-3.927 6.854-1.791 15.835-6.307 27.571-13.492-6.351-25.078-8.1-27.626-3.65-3.057 5.336 8.047 17.57 24.806 27.322s32.822 13.327 35.879 7.99c2.549-4.448-4.746-13.687-16.948-22.286m-4.676 25.579a19.262 19.262 0 1 1-31.079-18.084 64.5 64.5 0 0 1-5.953-5.722 27.4 27.4 0 0 0-5.778 7.046 27.784 27.784 0 0 0 10.073 37.74 27.4 27.4 0 0 0 40.63-18.647 63 63 0 0 1-7.893-2.333"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-907.969 -283)"
    />
  </svg>
);
export default SvgBabykino;
